import { MuiAlert, Skeleton, strIsNullOrEmpty, Typography } from '@fox/atoms';
import { FlexColumnSmallSpaced, FlexRowSpacedLarge } from '@fox/layout';
import { useGoalsContext } from '../../../goals-context';

export function GoalsSnapShot({ useLinkedOrganisationData }: { useLinkedOrganisationData: boolean }) {
	const { getGoalPointsCategories, getGoalsSnapShot, error, loading } = useGoalsContext();
	const snapShotData = getGoalsSnapShot(useLinkedOrganisationData);
	const totalPointsAcquired = snapShotData?.totalPointsAcquired;
	const totalPointsYTD = snapShotData?.totalPointsYTD;
	if (!strIsNullOrEmpty(error)) return <MuiAlert severity="error">{error}</MuiAlert>;
	return (
		<FlexRowSpacedLarge>
			<div>
				<Typography variant="caption" children={'Points YTD'} />
				{loading ? (
					<Skeleton />
				) : totalPointsYTD?.length ? (
					totalPointsYTD?.map(p => {
						const pointCategories = getGoalPointsCategories(useLinkedOrganisationData);
						const name = pointCategories.find(c => c.id === p.pointCategoryId)?.name;
						return (
							<Typography key={p.pointCategoryId} component={'div'} variant="subtitle2">
								{pointCategories.length > 1 ? <>{`${name}: ${p.points}`}</> : <>{p.points}</>}
							</Typography>
						);
					})
				) : (
					<Typography>0</Typography>
				)}
			</div>
			<div>
				<Typography variant="caption" children={'Points Total'} />
				<Typography variant="subtitle2" children={loading ? <Skeleton /> : totalPointsAcquired} />
			</div>
		</FlexRowSpacedLarge>
	);
}
